const styles = {
  card: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: { xs: '60vh', md: 'auto' },
  },
};

export default styles;
